import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["weight", "volume"]

  static values = {
    weightMax: { type: Number, default: 9999 },
    volumeMax: { type: Number, default: 120 },
    decimals: { type: Number, default: 2 }
  }

  connect() {
    this.setupField(this.weightTarget, this.weightMaxValue)
    this.setupField(this.volumeTarget, this.volumeMaxValue)

    this.normalizeField(this.weightTarget)
    this.normalizeField(this.volumeTarget)
  }

  normalize(event) {
    this.normalizeField(event.target)
  }

  setupField(input, maxValue) {
    if (!input) return

    input.setAttribute("inputmode", "decimal")
    input.setAttribute("min", "0")
    input.setAttribute("step", "0.01")
    input.setAttribute("max", String(maxValue))
  }

  normalizeField(input) {
    if (!input) return

    const maxValue = this.maxForField(input)
    const cleaned = this.cleanDecimal(input.value)

    if (cleaned === "") {
      input.value = ""
      input.setCustomValidity("")
      return
    }

    let numericValue = Number(cleaned)
    if (!Number.isFinite(numericValue)) {
      input.value = ""
      input.setCustomValidity("")
      return
    }

    if (numericValue < 0) numericValue = 0
    if (Number.isFinite(maxValue) && numericValue > maxValue) {
      numericValue = maxValue
    }

    input.value = this.formatForInput(numericValue)
    input.setCustomValidity("")
  }

  maxForField(input) {
    if (input === this.weightTarget) return this.weightMaxValue
    if (input === this.volumeTarget) return this.volumeMaxValue

    const parsed = Number(input.max)
    return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY
  }

  cleanDecimal(value) {
    const source = String(value || "").trim()
    if (!source || /[eE]/.test(source)) return ""

    const raw = source
      .replace(",", ".")
      .replace(/[^0-9.]/g, "")

    if (!raw) return ""

    const firstDot = raw.indexOf(".")
    const normalized = firstDot >= 0
      ? `${raw.slice(0, firstDot + 1)}${raw.slice(firstDot + 1).replace(/\./g, "")}`
      : raw

    const [integerPartRaw, decimalPartRaw = ""] = normalized.split(".")
    const integerPart = integerPartRaw.replace(/^0+(?=\d)/, "")
    const decimalPart = decimalPartRaw.slice(0, this.decimalsValue)

    if (decimalPart.length > 0) {
      return `${integerPart || "0"}.${decimalPart}`
    }

    return integerPart
  }

  formatForInput(value) {
    const rounded = Number(value).toFixed(this.decimalsValue)
    return rounded.replace(/\.?0+$/, "")
  }
}
